import React, { useEffect, useState } from "react";
import { basePath } from "./config";
import { useAuth } from "../contexts/auth";
import ShimmerTable from "./shimmer/ShimmerTable";
import { NotificationAction, NotificationType } from "../enums";
import { Link } from "react-router-dom";
import { format, formatDistanceToNow } from "date-fns";

export default function NotificationPage() {
  const [{ activeUser }] = useAuth();
  const [notifications, setNotifications] = useState(undefined);

  useEffect(() => {
    (async () => {
      const data = await fetch(basePath + "getNotifications", {
        method: "post",
        headers: {
          Authorization: `Bearer ${activeUser?.remember_token}`,
        },
      });

      const notifications = await data.json();
      if (notifications.status) {
        setNotifications(JSON.parse(notifications.data));
      } else {
        setNotifications([]);
      }
    })();
  }, []);

  async function markAsRead(id) {
    const data = await fetch(basePath + "notificationMarksAsRead", {
      method: "post",
      headers: {
        Authorization: `Bearer ${activeUser?.remember_token}`,
        "Content-Type": "application/json", // Add the content-type header
      },
      body: JSON.stringify({ id }),
    });

    const notifications = await data.json();
    if (notifications.status) {
      setNotifications(JSON.parse(notifications.data));
    }
  }

  if (notifications === undefined) {
    return <ShimmerTable />;
  }
  // console.log(notifications);

  return (
    <div className="h-full overflow-auto p-4">
      <div className="container mx-auto max-w-7xl">
        {notifications.map(
          ({
            id,
            order,
            notification_type,
            action,
            isUnreaded,
            user,
            order_id,
            created_at,
          }) => {
            return (
              <Link to={`../order-details/${order_id}`} key={id}>
                <div
                  onClick={(e) => markAsRead(id)}
                  className="p-4 mb-4 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400"
                  role="alert"
                >
                  <div className="flex gap-6">
                    <p className="flex-grow">
                      <span className="font-medium">{`${order?.party_name?.toUpperCase()}'s`}</span>
                      {` ${NotificationType[notification_type]} Order ${NotificationAction[action]} by ${user.name}`}
                    </p>

                    <div>
                      {isUnreaded == 1 && (
                        <button
                          className="px-2 py-1 text-xs font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          Mark as Read
                        </button>
                      )}
                      {/* <p>
                      {format(new Date(created_at), "dd-MM-yyyy, hh:mm aa")}
                    </p> */}
                      <p className="mt-1 text-xs">
                        {formatDistanceToNow(new Date(created_at), {
                          addSuffix: true,
                        })}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            );
          }
        )}
      </div>
    </div>
  );
}
